module.exports = __webpack_public_path__ + "img/intuit_logo_white.691f3360.svg";